import React, { FC } from 'react'

import { IconBookProps } from './IconBook.types'
import * as Styled from './styles/IconBook.style'

import { nonThemeableRules } from '../../ruleSet'

const IconBook: FC<IconBookProps> = ({
  size = nonThemeableRules.defaultSize as number as IconBookProps['size'],
  isResponsive = false,
}: IconBookProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M24 12.063v28.094a.085.085 0 0 1-.1.086c-1.185-.218-12.55-2.31-14.15-2.73C5 36.263 5 32.963 5 30.763v-14.7a4 4 0 0 1 4-4h1.832'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M24 12.063v28.094a.085.085 0 0 0 .1.086c1.185-.218 12.55-2.31 14.15-2.73 4.75-1.25 4.75-4.55 4.75-6.75v-14.7a4 4 0 0 0-4-4h-2.167'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M29.817 7.667a7.25 7.25 0 0 0-2.022.545C25.022 9.447 24 11.828 24 13.762V38.87a.085.085 0 0 0 .142.065c.5-.448 2.306-1.983 3.686-2.672 2-1 3-1.25 5.25-1.75 2.21-.5 3.75-2 3.75-4.5V6.762l-7.01.904Z'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
        <path
          d='M19.582 7.512c-2.75-.75-3.75-.75-3.75-.75-1.65 0-5 .25-5 4.75v18.5c0 1.65.525 4.13 3 4.75 2 .5 3.25.75 5.25 1.25 2.533.633 4.25 2.8 4.923 3.05v-25.55c-.172-2.485-1.672-5.25-4.422-6Z'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
        <path
          d='M32.5 23.2a20.766 20.766 0 0 0-4.5 2m4.5-7a20.766 20.766 0 0 0-4.5 2m4.5-7a20.766 20.766 0 0 0-4.5 2m-8 10a20.766 20.766 0 0 0-4.5-2m4.5-3a20.766 20.766 0 0 0-4.5-2m4.5-3a20.766 20.766 0 0 0-4.5-2'
          stroke='#E60000'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconBook
